module.exports = __webpack_public_path__ + "img/51626533_L.e07d4342.png";